import { en } from './en'

/**
 * Ops is an internal console for a small trained team, so it ships English
 * only — unlike the worker PWA and employer console, which face the public
 * and are bilingual. Copy here is dense and operational (audit actions,
 * dispute outcomes, rate floors); a second locale would be upkeep without
 * a reader.
 *
 * Kept behind the same `t()` signature so adding a locale later is a
 * translation task, not a refactor.
 */
/**
 * Walks a dotted path, but also matches keys that CONTAIN dots.
 *
 * Audit actions are keyed by their wire value (`'vetting.stage_passed'`), so
 * `audit.action.vetting.stage_passed` must resolve the last two segments as
 * one key rather than two. At each step, try the longest remaining join
 * first and fall back to a single segment.
 */
function resolve(path: string): string {
  const parts = path.split('.')
  let node: unknown = en
  let i = 0

  while (i < parts.length) {
    if (!node || typeof node !== 'object') return path
    const record = node as Record<string, unknown>

    let matched = false
    for (let take = parts.length - i; take >= 1; take--) {
      const key = parts.slice(i, i + take).join('.')
      if (key in record) {
        node = record[key]
        i += take
        matched = true
        break
      }
    }
    if (!matched) return path
  }

  return typeof node === 'string' ? node : path
}

export function t(path: string, params?: Record<string, string | number>): string {
  let out = resolve(path)

  if (out.includes('|')) {
    const forms = out.split('|').map(s => s.trim())
    const n = Number(params?.n ?? 0)
    out = (n === 1 ? forms[0] : forms[1]) ?? forms[0] ?? ''
  }

  if (params) {
    for (const [key, value] of Object.entries(params)) {
      out = out.replaceAll(`{${key}}`, String(value))
    }
  }
  return out
}

export { en }
